/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
  Checkbox,
  DatePicker,
  Table,
  Button,
  Popconfirm,
  Space,
  Dropdown as AntDropdown,
  Menu,
  Tooltip,
  Tag,
  Modal,
} from 'antd';
import moment from 'moment';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import {
  DownOutlined,
  RightCircleOutlined,
  VideoCameraOutlined,
  TruckOutlined,
  MoreOutlined,
  EditOutlined,
} from '@ant-design/icons';

import { InputInterface, OnAddArguments } from '../../../utils/forms/FormInterface';
import useEffectExcludingMount from '../../../hooks/useEffectExcludingMount';
import allowTableShort from '../../../utils/TableShort';
import DefaultTableHeader from './DefaultTableHeader';
import callApi from '../../../Api/config';
import Dropdown from '../../../components/Dropdown';
import { Text, FontVariant } from '../../../components/Text';
import GenericTable from '../../../components/GenericTable';

import '../entity.scss';
import {
  AppRoutes,
  isDocumitraMemberOnHold,
  isDocumitraMemberRejectedByAuthority,
} from '../../../constants/AppConstant';
import DownloadData from '../../../components/DownloadData';
import { formatDate } from '../../../utils/functions';
import ConfirmationModal from '../../../components/ConfirmationModal';
import { toastError, toastSuccess } from '../../../service/Toast';

import {
  ABOUT_PAGE_OUR_TEAM,
  ADVANTAGE_PAGE_ENTITY,
  APPLICATION_FORM_SERVICES,
  APPLICATION_FORM_PACKAGES,
  CONTACT_INFO,
  DOCUMITRA_LOGS,
  DOCUMITRA_ORDER_APPLICATION,
  DOCUMITRA_ORDER_TRANSACTION,
  DOCUMITRA_PARTNERS,
  PARTNER_SERVICES,
  SERVICE_CARDS_MANAGEMENT,
  HOW_IT_WORKS_PAGE_ENTITY,
  ORDER_USER,
  PHOTO_ORDER_APPLICATION,
  PHOTO_ORDER_TRANSACTION,
  PHOTOMITRA_ADVANTAGE_PAGE_ENTITY,
  PHOTOMITRA_HOW_IT_WORKS_PAGE_ENTITY,
  PHOTOMITRA_TAKING_PHOTO_STEPS_PAGE_ENTITY,
  REFFERAL_DETAILS,
  RELATED_ARTICLE,
  REVIEWS_PAGE_ENTITY,
  USERS_ENTITY,
  PARTNER_ORDERS,
} from '../../../constants/EntityName';

import { BASE_IMAGE_URL } from '../../../env';
import AddOnIcon from '../../../components/AddOnIcon';
import { TabCountContext } from '../AbstractTabs';

type FilterList = any;

interface AbstractLandingProps {
  headerName: string;
  entityName: string;
  tableHeaders: Array<InputInterface>;
  refreshData?: boolean | number;
  onAdd?: (argument1?: OnAddArguments) => void;
  onAddStep?: () => void;
  onSlotClick?: any;
  addName?: string;
  hideAddPrefix?: boolean;
  entityId?: string;
  code?: string;
  disableAdd?: boolean;
  disableSearch?: boolean;
  filtersList?: FilterList[];
  setFiltersList?: React.Dispatch<React.SetStateAction<FilterList[]>>;
  handleEdit?: (userData: any) => void;
  orderStatusQueryParams?: any;
  showDownload?: boolean;
  showFilter?: boolean;
  filterListData?: any;
  onTotalCountChange?: (count: number | undefined, countText: string) => void;
  countText?: string;
  initialFilters?: Record<string, any>;
  reportRedirectPath?: string;
}

let previousPaginationCount = 0;

// Create a custom debounce utility function
function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number
): (...args: Parameters<T>) => void {
  let timeout: NodeJS.Timeout | null = null;

  return function executedFunction(...args: Parameters<T>) {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      func(...args);
    }, wait);
  };
}

const AbstractLanding = (props: AbstractLandingProps) => {
  const { entityName, onSlotClick, disableSearch, filtersList } = props;
  const tabCountCtx = React.useContext(TabCountContext);
  const [apiListingData, setApiListingData] = useState<any>([] as any);
  const [loading, setLoading] = useState(false);
  const [memberStatusLoadingStates, setMemberStatusLoadingStates] = useState<{
    [key: string]: boolean;
  }>({});
  const [reminderLoadingStates, setReminderLoadingStates] = useState<{
    [key: string]: boolean;
  }>({});
  const adminRole = localStorage.getItem('role');
  const history = useHistory();

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const [totalCount, setTotalCount] = useState<number>();
  const [searchQuery, setSearchQuery] = useState<string>();
  const [searchPhoneQuery, setPhoneSearchQuery] = useState<string>();
  const [searchCityQuery, setCitySearchQuery] = useState<string>();
  const [searchStateQuery, setStateSearchQuery] = useState<string>();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [recordToDelete, setRecordToDelete] = useState<any>(null);
  const [AllBuckets, setAllBuckets] = useState<any>([]);
  const [filterSearch, setFilterSearch] = useState<any>(props.initialFilters || null);
  const [disableAddBtn, setDisableAddBtn] = useState(props.disableAdd);
  const [columnFilters, setColumnFilters] = useState<{ [key: string]: any }>({});

  const [selectedFilter, setSelectedFilter] = useState<
    Array<{ key: string; value: CheckboxValueType[] }>
  >([]);
  const filterQuery = (filterQuery: any) => {
    setFilterSearch(filterQuery);
  };

  const entityNameArrayList = [
    ADVANTAGE_PAGE_ENTITY,
    REVIEWS_PAGE_ENTITY,
    HOW_IT_WORKS_PAGE_ENTITY,
    PHOTOMITRA_ADVANTAGE_PAGE_ENTITY,
    PHOTOMITRA_HOW_IT_WORKS_PAGE_ENTITY,
    PHOTOMITRA_TAKING_PHOTO_STEPS_PAGE_ENTITY,
    APPLICATION_FORM_SERVICES,
  ];

  const handleConfirmDelete = async () => {
    if (!recordToDelete) return;
    try {
      const res: any = await callApi(`${entityName}/${recordToDelete.id}`, 'DELETE');
      if (res?.status) {
        toastSuccess('Record deleted successfully');
        getData();
      } else {
        toastError(res?.data?.message || 'Failed to delete record');
      }
    } catch (e) {
      toastError('An error occurred while deleting');
    }
    setDeleteModalOpen(false);
    setRecordToDelete(null);
  };

  const handleCancelDelete = () => {
    setDeleteModalOpen(false);
    setRecordToDelete(null);
  };

  const getData = async (paginationEvent: any = pagination) => {
    let queryParams: any = {};
    let res: any;

    // Add cache-busting parameter to prevent stale data
    queryParams._t = Date.now();

    if (props.entityId && props.code) {
      queryParams[props.code] = props.entityId;
    }

    if (filterSearch) {
      queryParams = { ...queryParams, ...filterSearch };
    }

    if (paginationEvent) {
      const { current, pageSize } = paginationEvent;
      queryParams.page = current;
      queryParams.limit = pageSize;
    }

    if (searchQuery) {
      if (entityName === DOCUMITRA_ORDER_APPLICATION) {
        queryParams.search = searchQuery;
        queryParams.searchFields = 'orderId,applicantName,email,mobileNumber';
      } else if (entityName === PARTNER_ORDERS) {
        queryParams.search = searchQuery;
        queryParams.searchFields =
          'groupCode,groupName,partner.companyName,partner.partnerName,partner.email,members.status,members.name,members.email';
      } else if (entityName === AppRoutes.OrderList) {
        queryParams.orderId = searchQuery;
      } else if (entityName === ORDER_USER) {
        queryParams.search = searchQuery;
        queryParams.searchFields = 'name,email,phone';
      } else {
        queryParams.search = searchQuery;
      }
    }

    if (searchPhoneQuery) {
      queryParams.phone = searchPhoneQuery;
    }

    if (searchCityQuery) {
      queryParams.city = searchCityQuery;
    }

    if (searchStateQuery) {
      queryParams.state = searchStateQuery;
    }

    if (selectedFilter.length) {
      selectedFilter?.forEach(v => {
        queryParams[v.key] = v.value.join(',');
      });
    }

    // Add column filters (like heading filter)
    if (columnFilters.heading && columnFilters.heading.length > 0) {
      queryParams.heading = columnFilters.heading[0]; // Take first selected value
    }

    setLoading(true);

    // Handle authentication errors
    const handleApiCall = async (
      url: string,
      method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH',
      body: any = null,
      params: any = null
    ) => {
      try {
        if (!params || !params.page || !params.limit) {
          return await callApi(url, method, body);
        } else {
          return await callApi(url, method, body, params);
        }
      } catch (error: any) {
        if (error?.status === 401) {
          // Handle authentication error
          toastError('Authentication required. Please login again.');
          localStorage.removeItem('token');
          window.location.href = '/login';
          return null;
        }
        throw error;
      }
    };

    res = await handleApiCall(props.entityName, 'GET', null, queryParams);

    if (!res) {
      setLoading(false);
      return;
    }

    if (entityName === AppRoutes.ContactForm || entityName === DOCUMITRA_PARTNERS) {
      res?.data?.data?.results?.forEach((item: any) => {
        item.createdAt = formatDate(item.createdAt);
      });
    }

    if (entityName === DOCUMITRA_ORDER_APPLICATION) {
      if (res?.data?.data?.results) {
        console.log('=== FRONTEND DEBUG: DOCUMITRA_ORDER_APPLICATION ===');
        console.log('Raw API Response:', res?.data?.data?.results);

        res.data.data.results = res?.data?.data?.results?.map((i: any) => {
          console.log('Processing item:', i);
          console.log('Item paymentDetails:', i?.paymentDetails);
          console.log('Item paymentDetails.paymentStatus:', i?.paymentDetails?.paymentStatus);

          return {
            ...i,
            paymentStatus: i?.paymentDetails?.paymentStatus || '--',
            members: i?.members || [],
            createdAt: formatDate(i?.createdAt),
          };
        });

        console.log('Processed results:', res.data.data.results);
        setApiListingData(res?.data?.data?.results);
      }
    }
    if (entityName === PARTNER_ORDERS) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => {
          return {
            ...i,
            partnerCompany: i?.partner?.partnerName || i?.partner?.companyName || '--',
            partnerEmail: i?.partner?.email || '--',
            createdAt: i?.createdAt,
          };
        });
        setApiListingData(res?.data?.data?.results);
      }
    }
    if (entityName === PHOTO_ORDER_APPLICATION) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => ({
          ...i,
          paymentStatus: i?.paymentDetails?.paymentStatus,
          createdAt: formatDate(i?.createdAt),
        }));
        //eslint-disable-next-line
        setApiListingData(res?.data?.data?.results);
      }
    }

    if (entityName === ORDER_USER) {
      if (res?.data?.data?.results) {
        const filteredOrderActivity = filterSearch?.orderActivity;
        res.data.data.results = res?.data?.data?.results?.map((i: any) => {
          const hasOrderCount =
            Number(i?.totalOrderCount || i?.orderCount || i?.ordersCount || 0) > 0 ||
            Number(i?.documitraOrderCount || i?.photoOrderCount || 0) > 0 ||
            Number(i?.applicationCount || i?.applicationsCount || 0) > 0;
          const hasOrderArrays =
            (Array.isArray(i?.orders) && i.orders.length > 0) ||
            (Array.isArray(i?.applications) && i.applications.length > 0) ||
            (Array.isArray(i?.documitraOrders) && i.documitraOrders.length > 0) ||
            (Array.isArray(i?.photoOrders) && i.photoOrders.length > 0);
          const explicitHasOrders =
            i?.hasOrders === true ||
            i?.hasDocumitraOrders === true ||
            i?.hasPhotoOrders === true ||
            i?.orderActivity === 'created';
          const inferredHasOrders = hasOrderCount || hasOrderArrays || explicitHasOrders;

          let finalOrderActivityLabel;
          let finalHasOrders;
          if (filteredOrderActivity === 'created') {
            finalOrderActivityLabel = 'Order Created';
            finalHasOrders = true;
          } else if (filteredOrderActivity === 'registeredOnly') {
            finalOrderActivityLabel = 'Registered Only (No Orders)';
            finalHasOrders = false;
          } else {
            finalOrderActivityLabel = inferredHasOrders
              ? 'Order Created'
              : 'Registered Only (No Orders)';
            finalHasOrders = inferredHasOrders;
          }

          return {
            ...i,
            hasOrders: finalHasOrders,
            orderActivity: finalHasOrders ? 'created' : 'registeredOnly',
            orderActivityLabel: i?.orderActivityLabel || finalOrderActivityLabel,
          };
        });
        setApiListingData(res.data.data.results);
      }
    }

    if (entityNameArrayList.includes(entityName)) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => {
          const imageUrl =
            i?.iconImage?.startsWith('https') || !i?.iconImage
              ? i?.iconImage
              : `${BASE_IMAGE_URL}${i?.iconImage?.startsWith('/') ? i?.iconImage : `/${i?.iconImage}`}`;
          console.log('Processing image URL:', {
            original: i?.iconImage,
            processed: imageUrl,
            baseUrl: BASE_IMAGE_URL,
          });
          return {
            ...i,
            iconImage: imageUrl,
          };
        });

        setApiListingData(res?.data?.data?.results);
      }
    }

    if (entityName === ABOUT_PAGE_OUR_TEAM || entityName === RELATED_ARTICLE) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => ({
          ...i,
          iconImage:
            i?.url?.startsWith('https') || !i?.url
              ? i?.url
              : `${BASE_IMAGE_URL}${i?.url?.startsWith('/') ? i?.url : `/${i?.url}`}`,
        }));
        setApiListingData(res?.data?.data?.results);
      }
    }

    // Apply bucket filtering for packages
    if (entityName === APPLICATION_FORM_PACKAGES) {
      if (res?.data?.data?.results) {
        setApiListingData(res?.data?.data?.results);
      }
    }

    if (entityName === DOCUMITRA_ORDER_TRANSACTION || entityName === PHOTO_ORDER_TRANSACTION) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => ({
          ...i,
          appliedCoupon: i?.appliedCoupon || 'N/A',
          paymentStatus: i?.paymentDetails?.paymentStatus || '--',
          transactionId: i?.paymentDetails?.transactionId || '--',
          paymentProvider: i?.paymentDetails?.provider || '--',
          amountPaid: i?.paymentDetails
            ? `${i?.paymentDetails?.currency} ${i?.paymentDetails?.amountPaid}`
            : '--',
          paymentDate: i?.paymentDetails?.paymentDate || '--',
        }));
        setApiListingData(res?.data?.data?.results);
      }
    }

    if (entityName === DOCUMITRA_LOGS) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => ({
          ...i,
          createdAt: formatDate(i?.createdAt),
        }));
        setApiListingData(res.data.data.results);
      }
    }

    if (entityName === REFFERAL_DETAILS) {
      if (res?.data?.data?.results) {
        res.data.data.results = res?.data?.data?.results?.map((i: any) => ({
          ...i,
          createdAt: formatDate(i?.createdAt),
        }));
        setApiListingData(res.data.data.results);
      }
    }

    if (entityName === SERVICE_CARDS_MANAGEMENT) {
      if (res?.data?.data?.results) {
        res.data.data.results = res.data.data.results.map((i: any) => ({
          ...i,
          heading: i?.category?.name || i?.heading || '--',
          categoryId: i?.category?.id || i?.categoryId,
        }));
        setApiListingData(res.data.data.results);
      }
    }

    if (res?.status && res?.data?.data?.results) {
      const apiData = res?.data?.data;

      if (entityName === CONTACT_INFO && apiData?.results?.length) {
        setDisableAddBtn(true);
      }

      const getTotalCount = () => {
        if (apiData?.totalCount !== undefined) {
          return apiData.totalCount;
        }
        if ('hasMore' in apiData) {
          const totalCount =
            apiData.hasMore === true ? (+apiData.page + 1) * 10 : +apiData.page * 10;

          return totalCount;
        }

        return res?.data?.data?.totalCount;
      };

      const totalCount = getTotalCount();
      setPaginationCount(totalCount);

      setApiListingData(res.data.data.results);
      setTotalCount(totalCount);
    } else if (res?.status && (Array.isArray(res?.data) || Array.isArray(res?.data?.data))) {
      const arrayData = Array.isArray(res?.data) ? res?.data : res?.data?.data;
      setApiListingData(arrayData);
      setTotalCount(arrayData.length);
    } else {
      setApiListingData([]);
    }

    setLoading(false);
  };

  const setPaginationCount = (currentPaginationCount: number) => {
    if (currentPaginationCount === previousPaginationCount) {
      return;
    }
    previousPaginationCount = currentPaginationCount;
    setTotalCount(currentPaginationCount);
  };

  const onPageChange = async (event: any) => {
    const newPagination = {
      current: event.current || 1,
      pageSize: event.pageSize || 10,
    };
    setPagination(newPagination);
    await getData(newPagination);
  };

  const onSummitFilter = (filterName: string, list: CheckboxValueType[]) => {
    const newFilter = selectedFilter.filter(value => value.key !== filterName);

    if (list.length) {
      newFilter.push({
        key: filterName,
        value: list,
      });
    }
    setSelectedFilter(newFilter);
  };

  useEffectExcludingMount(() => {
    if (searchQuery !== undefined) {
      getData({ ...pagination, current: 1 });
    }
    if (searchPhoneQuery !== undefined) {
      getData({ ...pagination, current: 1 });
    }
    if (searchCityQuery !== undefined) {
      getData({ ...pagination, current: 1 });
    }
    if (searchStateQuery !== undefined) {
      getData({ ...pagination, current: 1 });
    }
    if (filterSearch !== null) {
      getData({ ...pagination, current: 1 });
    }
  }, [searchQuery, searchPhoneQuery, searchCityQuery, searchStateQuery, filterSearch]);

  useEffectExcludingMount(() => {
    getData();
  }, [props.refreshData]);

  // THis is default api call for first time also
  useEffect(() => {
    getData({ ...pagination, current: 1 });
  }, [selectedFilter, entityName, columnFilters]);

  useEffect(() => {
    if (props.orderStatusQueryParams) {
      onSummitFilter('orderStatus', [props.orderStatusQueryParams]);
    }
  }, [props.orderStatusQueryParams]);

  const countText = props.headerName === 'Experts' ? 'Profiles' : 'Items';

  const finalCountText = props.countText || (props.headerName === 'Experts' ? 'Profiles' : 'Items');

  const pushCount = (count: number | undefined, text: string) => {
    if (props.onTotalCountChange) {
      props.onTotalCountChange(count, text);
    }
    if (tabCountCtx && tabCountCtx.setTabCount) {
      tabCountCtx.setTabCount(count);
    }
    if (tabCountCtx && tabCountCtx.setTabCountText) {
      tabCountCtx.setTabCountText(finalCountText || 'orders found');
    }
  };

  useEffectExcludingMount(() => {
    pushCount(totalCount, countText);
  }, [totalCount]);

  useEffect(() => {
    pushCount(totalCount, countText);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAddClick = (record: any) => {
    //eslint-disable-next-line
    // console.log(record);
    if (props.onAdd) {
      props.onAdd(record);
    }
  };

  const openRecordEntry = (record: any) => {
    onAddClick(record);
  };

  const getFilter = () => (
    <div className="flex">
      {filtersList?.map(filter => {
        switch (filter.filterType) {
          case 'DatePicker':
            return (
              <DatePicker
                key={filter.filterKey}
                allowClear
                suffixIcon={<DownOutlined />}
                className="date-filter"
                format="YYYY-MM-DD"
                name={filter.filterName}
                placeholder={filter.placeholder}
                onChange={(_, dateString) => onSummitFilter(filter.key, [dateString])}
              />
            );
          default:
            return (
              <Dropdown
                checkBoxOptions={filter.options}
                onSubmitFilter={onSummitFilter}
                filterName={filter.filterName}
                filterKey={filter.filterKey}
                key={filter.filterKey}
              />
            );
        }
      })}
    </div>
  );

  const handleCheckBoxClick = async (record: any) => {
    try {
      const updatedStatus = !record.active;
      const payload = {
        id: record.id,
        active: updatedStatus,
      };

      const res = await callApi('/users/update-status', 'PUT', payload);
      if (res?.data?.status === 1) {
        toastSuccess('Status updated successfully');
        getData(); // Refresh the table data
      } else {
        toastError(res?.data?.message || 'Failed to update status');
      }
    } catch (err: any) {
      console.error('Error updating status:', err);
      const errorMessage =
        err?.response?.data?.message || err?.message || 'Failed to update status';
      toastError(errorMessage);
    }
  };

  const columns: any = props.tableHeaders.map((tableMeta: any) => ({
    key: tableMeta.tableKey,
    title: tableMeta.tableLabel,
    dataIndex: tableMeta.tableKey,
    width:
      tableMeta.columnType === 'memberStatus'
        ? 200
        : tableMeta.columnType === 'memberNames'
          ? 200
          : undefined,
    colSpan: tableMeta.type === 'image' ? 0 : tableMeta.type === 'combinedColumn' ? 2 : null,
    // Add filter support for columns with filterOptions (server-side filtering)
    filters:
      tableMeta.enableFilter && tableMeta.filterOptions ? tableMeta.filterOptions : undefined,
    filteredValue: columnFilters[tableMeta.tableKey] || null,
    onFilter:
      tableMeta.enableFilter && tableMeta.filterOptions
        ? (value: any, record: any) => {
            // Server-side filtering - always return true, filtering handled by API
            return true;
          }
        : undefined,
    filterDropdown:
      tableMeta.enableFilter && tableMeta.filterOptions
        ? ({ setSelectedKeys, selectedKeys, confirm, clearFilters }: any) => {
            const handleFilter = () => {
              if (selectedKeys && selectedKeys.length > 0) {
                setColumnFilters((prev: any) => ({
                  ...prev,
                  [tableMeta.tableKey]: selectedKeys,
                }));
              } else {
                setColumnFilters((prev: any) => {
                  const newFilters = { ...prev };
                  delete newFilters[tableMeta.tableKey];
                  return newFilters;
                });
              }
              confirm();
              getData({ ...pagination, current: 1 });
            };

            const handleReset = () => {
              setSelectedKeys([]);
              setColumnFilters((prev: any) => {
                const newFilters = { ...prev };
                delete newFilters[tableMeta.tableKey];
                return newFilters;
              });
              clearFilters();
              getData({ ...pagination, current: 1 });
            };

            return (
              <div style={{ padding: 8 }}>
                <div style={{ marginBottom: 8, maxHeight: '200px', overflowY: 'auto' }}>
                  {tableMeta.filterOptions.map((option: any) => (
                    <label
                      key={option.value}
                      style={{ display: 'block', padding: '4px 0', cursor: 'pointer' }}
                    >
                      <input
                        type="checkbox"
                        checked={selectedKeys?.includes(option.value)}
                        onChange={e => {
                          if (e.target.checked) {
                            setSelectedKeys([...(selectedKeys || []), option.value]);
                          } else {
                            setSelectedKeys(
                              selectedKeys?.filter((k: any) => k !== option.value) || []
                            );
                          }
                        }}
                        style={{ marginRight: 8 }}
                      />
                      {option.text}
                    </label>
                  ))}
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 8,
                    borderTop: '1px solid #f0f0f0',
                    paddingTop: 8,
                  }}
                >
                  <button
                    onClick={handleReset}
                    style={{
                      padding: '4px 12px',
                      border: '1px solid #d9d9d9',
                      borderRadius: 4,
                      background: 'white',
                      cursor: 'pointer',
                    }}
                  >
                    Reset
                  </button>
                  <button
                    onClick={handleFilter}
                    style={{
                      padding: '4px 12px',
                      backgroundColor: '#0b53d9',
                      color: 'white',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            );
          }
        : undefined,
    onCell: (record: any) => ({
      style: {
        cursor:
          tableMeta.allowAddRecordClick ||
          tableMeta.allowSlotRecordClick ||
          tableMeta.allowAddRedirectOnClicks
            ? 'pointer'
            : 'default',
        textDecoration:
          tableMeta.allowAddRecordClick ||
          tableMeta.allowSlotRecordClick ||
          tableMeta.allowAddRedirectOnClicks
            ? tableMeta.columnType === 'memberStatus'
              ? ''
              : 'underline'
            : '',
      },
      onClick: () => {
        if (tableMeta.allowAddRecordClick) {
          // This code may be used in future
          // if (routesEntityArray.includes(entityName)) {
          //     history.push(`${entityName}/${record?.id}`);
          // } else {
          openRecordEntry(record);
          // }
        }

        // if (tableMeta.allowAddRedirectOnClicks) {
        //     history.push(`${ORDER_LIST_ENTITY}/${record.order.id}`);
        // }

        if (tableMeta.allowSlotRecordClick) {
          const tableMetaUrl = tableMeta.url;

          if (tableMetaUrl) {
            history.push(`${entityName}/${record?.id}/${tableMetaUrl}`);
          } else {
            onSlotClick?.(tableMeta.tableKey, { id: record.id, name: record.name });
          }
        }
      },
    }),

    sorter:
      entityName === USERS_ENTITY
        ? (a: any, b: any) => a.name.localeCompare(b.name)
        : allowTableShort(tableMeta.enableSort, tableMeta.tableKey),

    render: (value: any, record: any, index: number) => {
      if (tableMeta.columnType === 'partnerIdSeries') {
        // Display the full partnerId format from backend: PRT/26/109
        const partnerId = record.partnerId;
        if (partnerId) {
          // If it's already in PRT/YY/NNN format, return as-is
          if (partnerId.match(/PRT\/\d+\/\d+/)) {
            return partnerId;
          }
          // If it's just a number, format it as PRT/YY/NNN
          const year = new Date().getFullYear().toString().slice(-2);
          const numericId = parseInt(partnerId, 10);
          if (!isNaN(numericId)) {
            return `PRT/${year}/${numericId.toString().padStart(3, '0')}`;
          }
          return partnerId;
        }
        // Fallback: calculate based on pagination (shouldn't happen if backend is working correctly)
        const year = new Date().getFullYear().toString().slice(-2);
        const startIndex = 1;
        const currentIndex = (pagination.current - 1) * pagination.pageSize + index;
        return `PRT/${year}/${(startIndex + currentIndex).toString().padStart(3, '0')}`;
      }
      if (tableMeta.columnType === 'lastReferralPartnerIdSeries') {
        // Show affiliate partner id only when this order was created via a referral.
        // If no referralCode exists, keep the cell blank.
        const referralCode = record.referralCode;
        if (!referralCode) return '';

        const partnerId = record.partnerId;
        if (!partnerId) return '--';
        if (partnerId.match(/PRT\/\d+\/\d+/)) return partnerId;

        const year = new Date().getFullYear().toString().slice(-2);
        const numericId = parseInt(partnerId, 10);
        if (!isNaN(numericId)) {
          return `PRT/${year}/${numericId.toString().padStart(3, '0')}`;
        }
        return partnerId;
      }
      if (tableMeta.columnType === 'status') {
        const color = record.status === 'Active' ? '#52c41a' : '#ff4d4f';
        return <span style={{ color, fontWeight: 500 }}>{record.status}</span>;
      }
      if (tableMeta.columnType === 'paymentStatus') {
        const label: string = value ? String(value).trim() : '';
        const norm = label.toLowerCase();
        let style: { bg: string; color: string; ring: string } = {
          bg: '#f1f5f9',
          color: '#475569',
          ring: 'rgba(71,85,105,0.2)',
        };
        if (norm === 'payment pending') {
          style = { bg: '#fffbeb', color: '#b45309', ring: 'rgba(180,83,9,0.2)' };
        } else if (norm === 'payment successful') {
          style = { bg: '#ecfdf5', color: '#047857', ring: 'rgba(5,150,105,0.2)' };
        } else if (norm === 'payment done') {
          style = { bg: '#ecfdf5', color: '#047857', ring: 'rgba(5,150,105,0.2)' };
        } else if (norm === 'refund issued') {
          style = { bg: '#fdf2f8', color: '#9d174d', ring: 'rgba(157,23,77,0.2)' };
        }
        const refundStatus = String(record?.refundStatus || record?.refundSummary?.status || '')
          .trim()
          .toUpperCase();
        const refundLabelMap: Record<string, string> = {
          PENDING: 'Requested',
          APPROVED: 'Approved',
          REJECTED: 'Rejected',
          REFUNDED: 'Refunded',
        };
        const refundColorMap: Record<string, string> = {
          PENDING: '#faad14',
          APPROVED: '#52c41a',
          REJECTED: '#f5222d',
          REFUNDED: '#13c2c2',
        };

        return (
          <div
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 4 }}
          >
            <span
              style={{
                display: 'inline-flex',
                width: 'fit-content',
                alignItems: 'center',
                borderRadius: '999px',
                padding: '2px 10px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'default',
                background: style.bg,
                color: style.color,
                boxShadow: `inset 0 0 0 1px ${style.ring}`,
              }}
            >
              {label || '—'}
            </span>
            {refundStatus && (
              <span
                style={{
                  display: 'inline-block',
                  padding: '2px 8px',
                  borderRadius: 4,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#fff',
                  backgroundColor: refundColorMap[refundStatus] || '#888',
                }}
              >
                Refund: {refundLabelMap[refundStatus] || refundStatus}
              </span>
            )}
          </div>
        );
      }
      if (tableMeta.columnType === 'simpleDate') {
        return value ? moment(value).format('DD/MM/YYYY') : '--';
      }
      if (tableMeta.columnType === 'currency') {
        return value ? `$${value}` : '--';
      }
      if (tableMeta.columnType === 'parameters') {
        // Helper to try parsing JSON strings if necessary
        const parseValue = (val: any) => {
          if (typeof val === 'string') {
            try {
              return JSON.parse(val);
            } catch (e) {
              return val; // return as string if not valid JSON
            }
          }
          return val;
        };

        const params: { label: string; values: string[] }[] = [];

        // We check for these specific keys as requested
        const keysToCheck = [
          { key: 'applyingFrom', label: 'Applying From' },
          { key: 'citizenship', label: 'Citizenship' },
          { key: 'destination', label: 'Destination' },
          { key: 'country', label: 'Country' },
          { key: 'visaType', label: 'Visa Type' },
          { key: 'processingTime', label: 'Processing Time' },
        ];

        keysToCheck.forEach(({ key, label }) => {
          let val = record[key];
          // Also check inside package if not found at root
          if (!val && record.package) {
            val = record.package[key];
          }

          if (val) {
            const parsed = parseValue(val);
            const values = Array.isArray(parsed) ? parsed : [String(parsed)];
            params.push({ label, values });
          }
        });

        if (params.length === 0) {
          return <span style={{ color: '#8c8c8c' }}>--</span>;
        }

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {params.map((param, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center' }}>
                <Tooltip
                  title={
                    <div
                      style={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: '4px',
                        maxWidth: '800px',
                        maxHeight: '500px',
                        overflowY: 'auto',
                        padding: '8px',
                      }}
                    >
                      {param.values.map((v, i) => (
                        <Tag key={i} style={{ margin: 0 }}>
                          {v}
                        </Tag>
                      ))}
                    </div>
                  }
                  color="white"
                  overlayStyle={{ maxWidth: '1000px' }}
                  overlayInnerStyle={{ color: 'black', maxWidth: 'none' }}
                >
                  <span
                    style={{
                      fontSize: '13px',
                      color: '#1890ff',
                      cursor: 'pointer',
                      borderBottom: '1px dashed #1890ff',
                    }}
                  >
                    {param.label} ({param.values.length})
                  </span>
                </Tooltip>
              </div>
            ))}
          </div>
        );
      }
      if (tableMeta.columnType === 'actions') {
        if (entityName === PARTNER_SERVICES) {
          const handleDeleteService = () => {
            setRecordToDelete(record);
            setDeleteModalOpen(true);
          };

          const menu = (
            <Menu>
              <Menu.Item key="delete" danger onClick={handleDeleteService}>
                Delete
              </Menu.Item>
            </Menu>
          );

          return (
            <AntDropdown overlay={menu} trigger={['click']}>
              <Button
                type="text"
                icon={<MoreOutlined style={{ fontSize: '18px', fontWeight: 'bold' }} />}
              />
            </AntDropdown>
          );
        }
        if (entityName === DOCUMITRA_PARTNERS) {
          const handlePartnerStatusUpdate = async (status: string) => {
            try {
              const recordId = record.id;
              const newStatus = status;

              // Create a deep copy of the current data
              const updatedData = [...apiListingData];
              const recordIndex = updatedData.findIndex(item => item.id === recordId);

              if (recordIndex !== -1) {
                // Optimistic update
                updatedData[recordIndex] = {
                  ...updatedData[recordIndex],
                  status: newStatus,
                };
                setApiListingData(updatedData);
              }

              // Make API call
              const apiUrl = `${entityName}/${recordId}`;
              const apiPayload = { status: newStatus };
              const res = await callApi(apiUrl, 'PATCH', apiPayload);

              if (res?.status && (res?.data?.isSuccess === 1 || res?.data?.statusCode === 200)) {
                if (res?.data?.data && recordIndex !== -1) {
                  updatedData[recordIndex] = {
                    ...updatedData[recordIndex],
                    status: res.data.data.status || newStatus,
                  };
                  setApiListingData(updatedData);
                }
                toastSuccess(`Status updated to ${newStatus}`);
              } else {
                // Revert on failure
                if (recordIndex !== -1) {
                  updatedData[recordIndex] = {
                    ...updatedData[recordIndex],
                    status: record.status,
                  };
                  setApiListingData(updatedData);
                }
                toastError(res?.data?.message || 'Failed to update status');
              }
            } catch (error) {
              console.error('Error updating status:', error);
              toastError('Failed to update status');
              // Revert state if needed (state is scoped to this closure, so reusing apiListingData directly might be tricky if not careful, but here we rebuild logic)
              // Ideally we should use a shared function, but inline is fine for now
              getData(); // Fallback refresh
            }
          };

          const menu = (
            <Menu>
              <Menu.Item
                key="active"
                onClick={() => handlePartnerStatusUpdate('Active')}
                disabled={record.status === 'Active'}
              >
                Active
              </Menu.Item>
              <Menu.Item
                key="inactive"
                onClick={() => handlePartnerStatusUpdate('Inactive')}
                disabled={record.status === 'Inactive'}
              >
                Inactive
              </Menu.Item>
            </Menu>
          );

          return (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <AntDropdown overlay={menu} trigger={['click']}>
                <Button
                  type="text"
                  icon={<MoreOutlined style={{ fontSize: '18px', fontWeight: 'bold' }} />}
                />
              </AntDropdown>
            </div>
          );
        }

        return (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <EditOutlined
              style={{ cursor: 'pointer', color: '#1890ff' }}
              onClick={() => openRecordEntry(record)}
            />
          </div>
        );
      }
      if (tableMeta.columnType === 'userName') {
        return `${record.firstName} ${record.lastName}`;
      }
      if (tableMeta.columnType === 'isVerified') {
        const isVerifiedBool =
          record.isVerified === 'Verified' ||
          record.isVerified === true ||
          record.isVerified === 'true' ||
          record.isVerified === 'True' ||
          record.isVerified === undefined ||
          record.isVerified === null;
        return isVerifiedBool ? 'Verified' : 'Unverified';
      }
      if (tableMeta.columnType === 'fileFormats') {
        return `${record?.fileFormats?.join(', ') || '--'}`;
      }

      if (tableMeta.columnType === 'orderIdHash') {
        return `${record.order.orderIdHash}`;
      }
      if (tableMeta.columnType === 'orderId') {
        return `${record.order.id}`;
      }
      if (tableMeta.columnType === 'countriesName') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.countries?.join(', ') || '--'}`;
      }
      if (tableMeta.columnType === 'transactionName') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.user?.name}`;
      }
      if (tableMeta.columnType === 'transactionEmail') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.user?.email}`;
      }
      if (tableMeta.columnType === 'citizenship') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.citizenship || '--'}`;
      }

      if (tableMeta.columnType === 'destination') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.destination || '--'}`;
      }
      if (tableMeta.columnType === 'applyingFrom') {
        // In that case the value will be undefined and hence the optional chaining
        return `${record?.applyingFrom || '--'}`;
      }
      if (tableMeta.columnType === 'bucket') {
        // In that case the value will be undefined and hence the optional chaining
        //eslint-disable-next-line
        console.log('bucketrecord', record);
        return `${record?.bucket || '--'}`;
      }

      if (tableMeta.columnType === 'displayName') {
        // when Items are deleted then the corresponding inventories are not deleted. In that case the value will be undefined and hence the optional chaining
        return value?.name || '--';
      }
      if (tableMeta.columnType === 'roleName') {
        // when Items are deleted then the corresponding inventories are not deleted. In that case the value will be undefined and hence the optional chaining
        return record?.role || '--';
      }
      if (tableMeta.columnType === 'orderUserName') {
        return `${record?.user?.name}`;
      }
      if (tableMeta.columnType === 'orderUserEmail') {
        return `${record?.user?.email}`;
      }
      if (tableMeta.columnType === 'orderPlan') {
        const planTitle = value || record?.pricingPlan?.title || record?.plan || '';

        if (planTitle === 'Online Consultation') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Tooltip title="Online Consultation">
                <img
                  src="/onlineconsultationicon.png"
                  alt="Online Consultation"
                  style={{ width: '25px', height: '25px' }}
                />
              </Tooltip>
            </div>
          );
        } else if (planTitle === 'Ready to Ship') {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Tooltip title="Ready to Ship">
                <img
                  src="/readytoshipicon.png"
                  alt="Ready to Ship"
                  style={{ width: '35px', height: '25px' }}
                />
              </Tooltip>
            </div>
          );
        }
        return '--';
      }
      if (tableMeta.columnType === 'facebookLink') {
        return `${record.socialMediaLinks.facebook} `;
      }
      if (tableMeta.columnType === 'facebookGroupLink') {
        return `${record.socialMediaLinks.facebookGroup} `;
      }
      if (tableMeta.columnType === 'youtubeLink') {
        return `${record.socialMediaLinks.youtube}`;
      }
      if (tableMeta.columnType === 'instagramLink') {
        return `${record.socialMediaLinks.instagram}`;
      }
      if (tableMeta.columnType === 'linkedInLink') {
        return `${record.socialMediaLinks.linkedIn}`;
      }
      if (tableMeta.columnType === 'youtubeLink') {
        return `${record.socialMediaLinks.youtube}`;
      }
      if (tableMeta.columnType === 'whatsappLink') {
        return `${record.socialMediaLinks.whatsappChat}`;
      }
      if (tableMeta.columnType === 'whatsappGrouplink') {
        return `${record.socialMediaLinks.whatsappGroup}`;
      }
      if (tableMeta.columnType === 'xLink') {
        return `${record.socialMediaLinks.x}`;
      }
      if (tableMeta.columnType === 'pinterestLink') {
        return `${record.socialMediaLinks.pinterest}`;
      }
      if (tableMeta.columnType === 'tiktokLink') {
        return `${record.socialMediaLinks.tiktok}`;
      }
      if (tableMeta.columnType === 'redditLink') {
        return `${record.socialMediaLinks.reddit}`;
      }
      if (tableMeta.columnType === 'checkbox') {
        const rawValue = entityName === USERS_ENTITY ? record.isActive : record.active;
        const isActiveBool =
          rawValue === 'Active' ||
          rawValue === true ||
          rawValue === 'true' ||
          rawValue === undefined ||
          rawValue === null;

        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Checkbox
              checked={isActiveBool}
              onChange={async () => {
                try {
                  const recordId = record.id;
                  const newBoolStatus = !isActiveBool;
                  const newStringStatus = newBoolStatus ? 'Active' : 'Inactive';

                  // Create a deep copy of the current data
                  const updatedData = [...apiListingData];
                  const recordIndex = updatedData.findIndex(item => item.id === recordId);

                  if (recordIndex !== -1) {
                    // Update the specific record in our copy
                    updatedData[recordIndex] = {
                      ...updatedData[recordIndex],
                      ...(entityName === USERS_ENTITY
                        ? { isActive: newStringStatus }
                        : { active: newStringStatus }),
                    };
                    // Update the state immediately for visual feedback
                    setApiListingData(updatedData);
                  }

                  // Make API call based on entity type
                  const endpoint =
                    entityName === USERS_ENTITY
                      ? '/admin/users/update-status'
                      : '/users/update-status';
                  const payload =
                    entityName === USERS_ENTITY
                      ? { id: recordId, isActive: newBoolStatus }
                      : { id: recordId, active: newBoolStatus };

                  const res = await callApi(endpoint, 'PUT', payload);

                  // If API call fails, revert the state
                  if (!res?.data?.status) {
                    if (recordIndex !== -1) {
                      updatedData[recordIndex] = {
                        ...updatedData[recordIndex],
                        ...(entityName === USERS_ENTITY
                          ? { isActive: isActiveBool ? 'Active' : 'Inactive' }
                          : { active: isActiveBool ? 'Active' : 'Inactive' }),
                      };
                      setApiListingData(updatedData);
                    }
                  }
                } catch (error) {
                  // On error, revert the state
                  const updatedData = [...apiListingData];
                  const recordIndex = updatedData.findIndex(item => item.id === record.id);

                  if (recordIndex !== -1) {
                    updatedData[recordIndex] = {
                      ...updatedData[recordIndex],
                      ...(entityName === USERS_ENTITY
                        ? { isActive: record.isActive }
                        : { active: record.active }), // Revert to original state
                    };
                    setApiListingData(updatedData);
                  }
                }
              }}
            />
          </div>
        );
      }
      if (tableMeta.columnType === 'booleanStatus') {
        // Handle string status values ('Active', 'Inactive', 'Pending') for Documitra Partners
        const statusValue = record.status !== undefined ? record.status : false;
        const isStringStatus = typeof statusValue === 'string';
        const isActive = isStringStatus
          ? statusValue === 'Active'
          : statusValue === true || statusValue === 'true';
        const isPending = isStringStatus && statusValue === 'Pending';

        return (
          <div
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
          >
            {isPending ? (
              <span style={{ color: '#faad14', fontWeight: 500 }}>Pending</span>
            ) : (
              <Checkbox
                checked={isActive}
                onChange={async checked => {
                  try {
                    const recordId = record.id;
                    // Toggle between 'Active' and 'Inactive' for string status, or true/false for boolean
                    const newStatus = isStringStatus
                      ? isActive
                        ? 'Inactive'
                        : 'Active'
                      : !isActive;

                    console.log('DEBUG: Status change initiated', {
                      recordId,
                      currentStatus: statusValue,
                      newStatus,
                      entityName,
                      isStringStatus,
                    });

                    // Create a deep copy of the current data
                    const updatedData = [...apiListingData];
                    const recordIndex = updatedData.findIndex(item => item.id === recordId);

                    if (recordIndex !== -1) {
                      // Update the specific record in our copy
                      updatedData[recordIndex] = {
                        ...updatedData[recordIndex],
                        status: newStatus,
                      };
                      // Update the state immediately for visual feedback
                      setApiListingData(updatedData);
                    }

                    // Make API call to update partner status
                    const apiUrl = `${entityName}/${recordId}`;
                    const apiPayload = { status: newStatus };

                    console.log('DEBUG: Making API call', {
                      url: apiUrl,
                      method: 'PATCH',
                      payload: apiPayload,
                    });

                    const res = await callApi(apiUrl, 'PATCH', apiPayload);

                    console.log('DEBUG: API response received', {
                      res,
                      status: res?.status,
                      data: res?.data,
                      isSuccess: res?.data?.isSuccess,
                      statusCode: res?.data?.statusCode,
                    });

                    // Check if API call was successful
                    // Response structure: { data: { data: {...partner...}, isSuccess: 1, statusCode: 200 }, status: true }
                    if (
                      res?.status &&
                      (res?.data?.isSuccess === 1 || res?.data?.statusCode === 200)
                    ) {
                      // Update the local state with the actual response data if available
                      if (res?.data?.data && recordIndex !== -1) {
                        updatedData[recordIndex] = {
                          ...updatedData[recordIndex],
                          status: res.data.data.status || newStatus, // Use status from response
                        };
                        setApiListingData(updatedData);
                      }
                      toastSuccess(
                        `Partner ${newStatus === 'Active' || newStatus === true ? 'activated' : 'deactivated'} successfully`
                      );
                    } else {
                      // If API call fails, revert the state
                      console.error('DEBUG: API call failed', res);
                      if (recordIndex !== -1) {
                        updatedData[recordIndex] = {
                          ...updatedData[recordIndex],
                          status: statusValue, // Revert to original state
                        };
                        setApiListingData(updatedData);
                      }
                      const errorMsg = res?.data?.message || 'Failed to update partner status';
                      toastError(errorMsg);
                    }
                  } catch (error) {
                    // On error, revert the state
                    console.error('DEBUG: Error updating partner status', error);
                    const updatedData = [...apiListingData];
                    const recordIndex = updatedData.findIndex(item => item.id === record.id);

                    if (recordIndex !== -1) {
                      updatedData[recordIndex] = {
                        ...updatedData[recordIndex],
                        status: statusValue, // Revert to original state
                      };
                      setApiListingData(updatedData);
                    }
                    const errorMessage =
                      (error as any)?.message ||
                      'Failed to update partner status. Please try again.';
                    toastError(errorMessage);
                  }
                }}
              />
            )}
          </div>
        );
      }

      if (tableMeta.columnType === 'contactNumbersMultiple') {
        return `${record.contactNumbers.join(' | ')}`;
      }

      if (tableMeta.columnType === 'phoneWithCountry') {
        const phoneVal = value || record?.phone || '';
        if (!phoneVal) return '--';
        const lastDashIndex = phoneVal.lastIndexOf('-');
        if (lastDashIndex !== -1) {
          const cc = phoneVal.substring(0, lastDashIndex);
          const num = phoneVal.substring(lastDashIndex + 1);
          return cc && num ? `${cc} ${num}` : phoneVal;
        }
        return phoneVal;
      }

      if (tableMeta.columnType === 'documentsDisplayNameObject') {
        return (
          record?.documents
            ?.map((documentDisplayNameObject: { name: string }) => documentDisplayNameObject?.name)
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'featureDisplayNameObject') {
        return (
          record?.features
            ?.map(
              (featuresDisplayNameObject: { description: string }) =>
                featuresDisplayNameObject?.description
            )
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'adminusers') {
        return (
          record?.adminusers.map((adminuser: { name: string }) => adminuser).join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'serviceAttributesDisplayNameObject') {
        return (
          record?.serviceAttributes
            ?.map(
              (serviceAttributeDisplayNameObject: { name: string }) =>
                serviceAttributeDisplayNameObject?.name
            )
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'plansDisplayNameObject') {
        return (
          record?.plans
            ?.map((planDisplayNameObject: { title: string }) => planDisplayNameObject?.title)
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'questionsDisplayNameObject') {
        return (
          record?.questions
            ?.map(
              (questionsDisplayNameObject: { questionText: string }) =>
                questionsDisplayNameObject?.questionText
            )
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'formStepsDisplayNameObject') {
        return (
          record?.steps
            ?.map(
              (formStepsDisplayNameObject: { stepTitle: string }) =>
                formStepsDisplayNameObject?.stepTitle
            )
            ?.join(', ') || '--'
        );
      }

      if (tableMeta.columnType === 'parametersDisplayNameObject') {
        // return (
        //     record?.parameters
        //         ?.map((parametersDisplayNameObject: { name: string }) => parametersDisplayNameObject?.name)
        //         ?.join(', ') || '--'
        // );
        return `${record?.parameters?.join(', ') || '--'}`;
      }

      if (tableMeta.columnType === 'packageName') {
        return `${record?.package?.name || '--'}`;
      }

      if (tableMeta.columnType === 'packageId') {
        return `${record?.package?.id || '--'}`;
      }

      if (tableMeta.columnType === 'questionName') {
        return `${`${record?.question?.label}-${record?.question?.inputType}` || '--'}`;
      }

      if (tableMeta.columnType === 'displayNameTitle') {
        return `${record?.title?.heading || '--'}`;
      }

      if (tableMeta.columnType === 'serviceName') {
        return `${record?.service?.name || '--'}`;
      }
      if (tableMeta.columnType === 'serviceNames') {
        // Use the serviceNames field that comes from the backend
        return record?.serviceNames || '--';
      }
      if (tableMeta.columnType === 'packageName') {
        return `${record?.package?.name || '--'}`;
      }
      if (tableMeta.columnType === 'packageId') {
        return `${record?.package?.id || '--'}`;
      }
      if (tableMeta.columnType === 'termsName') {
        return `${record?.term?.name || '--'}`;
      }

      if (tableMeta.columnType === 'displayNameObjectArray') {
        return value
          ?.map(
            (displayNameObject: { name: string; mobile: string }) =>
              `${displayNameObject?.name} - ${displayNameObject?.mobile}`
          )
          .join(', ');
      }

      if (tableMeta.columnType === 'password') {
        // when Items are deleted then the corresponding inventories are not deleted. In that case the value will be undefined and hence the optional chaining
        return value?.password || '********';
      }

      if (tableMeta.columnType === 'clickHere') {
        return <AddOnIcon record={record} />;
      }

      if (tableMeta.columnType === 'partner') {
        return record?.partner?.partnerName || '--';
      }

      if (tableMeta.columnType === 'partnerService') {
        return record?.partnerPackage?.name || record?.partnerPackage?.package?.name || '--';
      }

      if (tableMeta.columnType === 'planType') {
        const ready =
          record?.partnerPackage?.readyToShip === true ||
          record?.partnerPackage?.readyToShip === 'true';

        if (ready) {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Tooltip title="Ready to Ship">
                <img
                  src="/readytoshipicon.png"
                  alt="Ready to Ship"
                  style={{ width: '35px', height: '25px' }}
                />
              </Tooltip>
            </div>
          );
        }
        return (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Tooltip title="Online Consultation">
              <img
                src="/onlineconsultationicon.png"
                alt="Online Consultation"
                style={{ width: '25px', height: '25px' }}
              />
            </Tooltip>
          </div>
        );
      }

      if (tableMeta.columnType === 'membersList') {
        const members = record?.members || [];
        if (!members.length) return '--';

        return (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', minWidth: '200px' }}>
            {members.map((m: any, idx: number) => {
              const status = m.status || 'Order Pending'; // Default to Order Pending to match image style slightly if null

              return (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '14px',
                  }}
                >
                  <span style={{ fontWeight: 500, color: '#000' }}>{m.name || 'Member'} :</span>
                  <span
                    style={{
                      color: '#1890ff',
                      cursor: 'pointer',
                      marginLeft: '12px',
                      textAlign: 'right',
                    }}
                  >
                    {status}
                  </span>
                </div>
              );
            })}
          </div>
        );
      }

      if (tableMeta.columnType === 'registrationDate') {
        if (!value) return '--';
        try {
          const date = new Date(value);
          if (Number.isNaN(date.getTime())) return value || '--';
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        } catch (error) {
          console.error('Date formatting error:', error);
          return value || '--';
        }
      }

      if (tableMeta.columnType === 'assignPackage') {
        return (
          <Button
            type="primary"
            size="small"
            onClick={e => {
              e.stopPropagation();
              onSlotClick?.('assignPackage', record);
            }}
          >
            Assign Packages
          </Button>
        );
      }

      if (tableMeta.columnType === 'package') {
        return `${record?.package?.name} (${record?.package?.service?.name})` || '--';
      }

      if (tableMeta.columnType === 'service') {
        return record?.package?.service?.name || record?.service?.name || '--';
      }

      if (tableMeta.columnType === 'price') {
        return value ? `$${value}` : '--';
      }

      if (tableMeta.columnType === 'date') {
        return moment(value).format('DD/MM/YYYY HH:mm');
      }

      if (tableMeta.columnType === 'simpleDate') {
        try {
          const date = new Date(value);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        } catch (error) {
          console.error('Date formatting error:', error);
          return 'Invalid Date';
        }
      }

      if (tableMeta.columnType === 'registrationDate') {
        if (!value) return '--';
        try {
          const date = new Date(value);
          if (Number.isNaN(date.getTime())) return value || '--';
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        } catch (error) {
          console.error('Date formatting error:', error);
          return value || '--';
        }
      }

      // if (tableMeta.columnType === 'dateAndTime') {
      //   return value?.split('.')[0].split('T').join(' ') || '--';
      // }

      if (tableMeta.columnType === 'active') {
        return value ? 'Yes' : 'No';
      }

      if (tableMeta.columnType === 'orderActivity') {
        const activity = record?.orderActivity;
        const hasExplicitLabel =
          record?.orderActivityLabel && record.orderActivityLabel.trim() !== '';
        const hasCount =
          Number(record?.totalOrderCount || 0) > 0 ||
          Number(record?.orderCount || 0) > 0 ||
          Number(record?.ordersCount || 0) > 0 ||
          Number(record?.documitraOrderCount || 0) > 0 ||
          Number(record?.photoOrderCount || 0) > 0 ||
          Number(record?.applicationCount || 0) > 0 ||
          Number(record?.applicationsCount || 0) > 0;
        const hasArrays =
          (Array.isArray(record?.orders) && record.orders.length > 0) ||
          (Array.isArray(record?.applications) && record.applications.length > 0) ||
          (Array.isArray(record?.documitraOrders) && record.documitraOrders.length > 0) ||
          (Array.isArray(record?.photoOrders) && record.photoOrders.length > 0);
        const hasFlags =
          record?.hasOrders === true ||
          record?.hasDocumitraOrders === true ||
          record?.hasPhotoOrders === true;
        const inferredCreated = activity === 'created' || hasFlags || hasCount || hasArrays;
        const filteredActivity = filterSearch?.orderActivity;

        let label;
        if (hasExplicitLabel) {
          label = record.orderActivityLabel;
        } else if (filteredActivity === 'created' && inferredCreated !== false) {
          label = 'Order Created';
        } else if (filteredActivity === 'registeredOnly' && inferredCreated !== true) {
          label = 'Registered Only (No Orders)';
        } else {
          label = inferredCreated ? 'Order Created' : 'Registered Only (No Orders)';
        }
        const isCreated = label === 'Order Created';

        return (
          <span
            style={{
              display: 'inline-block',
              padding: '2px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: 500,
              color: isCreated ? '#047857' : '#b45309',
              background: isCreated ? '#ecfdf5' : '#fffbeb',
            }}
          >
            {label}
          </span>
        );
      }

      if (tableMeta.columnType === 'sendReminder') {
        const recordId = record?.id || record?._id;
        const isSending = !!reminderLoadingStates[recordId];

        const handleSendReminder = async () => {
          setReminderLoadingStates(prev => ({ ...prev, [recordId]: true }));
          try {
            const res = await callApi(`${ORDER_USER}/${recordId}/send-reminder`, 'POST');
            const payload = res?.data;
            if (res?.status && (payload?.isSuccess === 1 || payload?.statusCode === 200)) {
              toastSuccess(payload?.message || 'Reminder sent');
            } else {
              // Backend rejects users whose payment is already done or who have no order.
              toastError(payload?.message || 'Could not send reminder');
            }
          } catch (error) {
            toastError('Could not send reminder');
          } finally {
            setReminderLoadingStates(prev => ({ ...prev, [recordId]: false }));
          }
        };

        return (
          <Popconfirm
            title="Send a reminder to complete the form and payment?"
            okText="Send"
            cancelText="Cancel"
            onConfirm={handleSendReminder}
            disabled={isSending}
          >
            <Button
              type="primary"
              size="small"
              loading={isSending}
              onClick={e => e.stopPropagation()}
            >
              Send Reminder
            </Button>
          </Popconfirm>
        );
      }

      if (tableMeta.columnType === 'memberNames') {
        if (record?.members && record.members.length > 0) {
          return (
            <div style={{ maxWidth: '200px' }}>
              {record.members.map((member: any, index: number) => (
                <div
                  key={member.id}
                  style={{
                    marginBottom: index < record.members.length - 1 ? '4px' : '0',
                    padding: '3px 6px',
                    borderRadius: '3px',
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#333',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                  }}
                  onClick={e => {
                    e.stopPropagation();
                    openRecordEntry(record);
                  }}
                >
                  {member.name}
                </div>
              ))}
            </div>
          );
        }
        return '--';
      }

      if (tableMeta.columnType === 'memberStatus') {
        if (record?.members && record.members.length > 0) {
          return (
            <div style={{ maxWidth: '250px' }}>
              {record.members.map((member: any, index: number) => {
                const derivedStatus =
                  member.status || (record.status ? record.status : 'Form Filling Under Process');
                const isRejectedByAuthority = isDocumitraMemberRejectedByAuthority(member);
                const isOnHold = isDocumitraMemberOnHold(member);

                return (
                  <div
                    key={member.id}
                    title={
                      [
                        isRejectedByAuthority && member.governmentStatusRemark
                          ? `Rejection remark: ${member.governmentStatusRemark}`
                          : '',
                        isOnHold && member.onHoldRemark ? `On hold: ${member.onHoldRemark}` : '',
                      ]
                        .filter(Boolean)
                        .join(' | ') || undefined
                    }
                    style={{
                      marginBottom: index < record.members.length - 1 ? '4px' : '0',
                      padding: '3px 6px',
                      borderRadius: '3px',
                      fontSize: '14px',
                      cursor: 'pointer',
                      color: isRejectedByAuthority ? '#b91c1c' : '#1890ff',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                    }}
                  >
                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {derivedStatus}
                    </span>
                    {isRejectedByAuthority && (
                      <span
                        style={{
                          flexShrink: 0,
                          padding: '1px 8px',
                          borderRadius: '999px',
                          border: '1px solid #fecaca',
                          backgroundColor: '#fef2f2',
                          color: '#b91c1c',
                          fontSize: '11px',
                          fontWeight: 700,
                          lineHeight: 1.4,
                          textTransform: 'uppercase',
                          letterSpacing: '0.02em',
                        }}
                      >
                        Rejected
                      </span>
                    )}
                    {isOnHold && (
                      <span
                        style={{
                          flexShrink: 0,
                          padding: '1px 8px',
                          borderRadius: '999px',
                          border: '1px solid #fed7aa',
                          backgroundColor: '#fff7ed',
                          color: '#c2410c',
                          fontSize: '11px',
                          fontWeight: 700,
                          lineHeight: 1.4,
                          textTransform: 'uppercase',
                          letterSpacing: '0.02em',
                        }}
                      >
                        On Hold
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          );
        }
        return '--';
      }

      if (tableMeta.columnType === 'image') {
        const imageUrl =
          value?.startsWith('https') || !value
            ? value
            : `${BASE_IMAGE_URL}${value?.startsWith('/') ? value : `/${value}`}`;
        console.log('Rendering image:', {
          original: value,
          processed: imageUrl,
          baseUrl: BASE_IMAGE_URL,
        });
        return (
          <div>
            {value && (
              <img
                src={imageUrl}
                style={{ borderRadius: '50%', height: '45px', width: '45px', overflow: 'hidden' }}
                onError={e => {
                  console.error('Image failed to load:', imageUrl);
                  e.currentTarget.style.display = 'none';
                }}
              />
            )}
          </div>
        );
      }

      if (tableMeta.columnType === 'action') {
        return (
          <Space>
            <Button
              type="primary"
              size="small"
              onClick={e => {
                e.stopPropagation();
                onSlotClick?.('edit', record);
              }}
            >
              Edit
            </Button>
            <Popconfirm
              title="Are you sure you want to delete this?"
              onConfirm={e => {
                e?.stopPropagation();
                onSlotClick?.('delete', record);
              }}
              onCancel={e => e?.stopPropagation()}
              okText="Yes"
              cancelText="No"
            >
              <Button type="primary" danger size="small" onClick={e => e.stopPropagation()}>
                Delete
              </Button>
            </Popconfirm>
          </Space>
        );
      }

      return value ?? '--';
    },
  }));

  // Create debounced setters using our custom debounce function
  const debouncedSetSearchQuery = React.useMemo(
    () => debounce((value: string) => setSearchQuery(value), 300),
    []
  );

  const debouncedSetPhoneSearchQuery = React.useMemo(
    () => debounce((value: string) => setPhoneSearchQuery(value), 300),
    []
  );

  const debouncedSetCitySearchQuery = React.useMemo(
    () => debounce((value: string) => setCitySearchQuery(value), 300),
    []
  );

  const debouncedSetStateSearchQuery = React.useMemo(
    () => debounce((value: string) => setStateSearchQuery(value), 300),
    []
  );

  // Build filters object from current filter states
  const buildFilters = () => {
    const filters: any = {};

    // Add filterSearch properties
    if (filterSearch) {
      Object.assign(filters, filterSearch);
    }

    // Add search query
    if (searchQuery) {
      filters.search = searchQuery;
    }

    // Add selected filter values
    if (selectedFilter.length) {
      selectedFilter.forEach(v => {
        if (v.value && v.value.length > 0) {
          // Handle array values - join if multiple, use first if single
          filters[v.key] =
            Array.isArray(v.value) && v.value.length > 1
              ? v.value.join(',')
              : Array.isArray(v.value)
                ? v.value[0]
                : v.value;
        }
      });
    }

    return filters;
  };

  // Update getHeader to use debounced setters
  const getHeader = () => (
    <DefaultTableHeader
      headerName={props.headerName}
      totalCount={totalCount}
      countText={props.countText || (props.headerName === 'Experts' ? 'Profiles' : 'Items')}
      onAdd={() => props.onAdd && props.onAdd()}
      setSearchQuery={debouncedSetSearchQuery}
      setPhoneSearchQuery={debouncedSetPhoneSearchQuery}
      setCitySearchQuery={debouncedSetCitySearchQuery}
      setStateSearchQuery={debouncedSetStateSearchQuery}
      addName={props.addName}
      hideAddPrefix={props.hideAddPrefix}
      disableAdd={disableAddBtn}
      disableSearch={disableSearch}
      showDownload={props.showDownload}
      reportRedirectPath={props.reportRedirectPath}
      entityName={entityName}
      showFilter={props.showFilter}
      items={props.filterListData}
      filterQuery={filterQuery}
      filters={props.initialFilters}
      // NOTE: DefaultTableHeader owns its filter UI state and pushes changes
      // back via `filterQuery`. Passing a freshly-created `filters` object here
      // causes its internal state to get overwritten on every render, which
      // breaks filters (especially on Partner Orders). Only pass filters if we
      // explicitly want to control the header state from the parent.
    />
  );

  return (
    <div className="landing-container">
      {getHeader()}
      {/* Old filters removed as they are now consolidated in DefaultTableHeader */}
      {/* <div className="dropdown-group">{getFilter()}</div> */}
      <Table
        columns={columns}
        loading={loading}
        dataSource={apiListingData}
        onChange={onPageChange}
        pagination={{ ...pagination, total: totalCount }}
        scroll={{ x: 'max-content' }}
        bordered
      />
      <ConfirmationModal
        open={deleteModalOpen}
        message={`Are you sure you want to delete?`}
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        onClose={handleCancelDelete}
      />
    </div>
  );
};

AbstractLanding.defaultProps = {
  refreshData: false,
};

export default AbstractLanding;
